<template>
  <div>
      <ax-step v-for="(item,index) in recordList" :key="index" :data="item" :comment="index===1?commentsList:[]"></ax-step>
  </div>
</template>
<script>
export default {
  data(){
    return {
			commentsList: [],
      recordList: [
		{
			"createTime": null,
			"updateTime": null,
			"createBy": null,
			"updateBy": null,
			"tenantId": null,
			"jumpId": null,
			"actDefId": null,
			"actInstId": null,
			"nodeName": null,
			"nodeId": null,
			"taskId": null,
			"completeTime": "2021-04-01 14:54:33",
			"duration": null,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": null,
			"jumpType": null,
			"remark": null,
			"enableMobile": 0,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": null,
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": null,
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": null,
			"checkStatusText": null,
			"identifyLabel": null,
			"durationFormat": "0秒",
			"jumpTypeText": ""
		},
		{
			"createTime": "2021-04-01 12:06:45",
			"updateTime": "2021-04-01 14:54:33",
			"createBy": "51585",
			"updateBy": "44904",
			"tenantId": "1",
			"jumpId": "2430000027905977",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "财务三审",
			"nodeId": "sid-B6F11740-7A67-44D0-AC77-77F96E5B1BA4",
			"taskId": "2430000027905976",
			"completeTime": "2021-04-01 14:54:33",
			"duration": 10067688,
			"durationVal": 10068000,
			"handlerId": "44904",
			"ownerId": null,
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": "同意",
			"enableMobile": 1,
			"handleDepId": "1004099",
			"handleDepFull": "360/政企安全集团/财务部",
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "张莉",
			"handlerInfo": {
				"handler": "张莉",
				"deptName": "政企安全集团.财务部",
				"photoId": "zhangli3-fin@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2430000027905977",
			"checkStatusText": "通过",
			"identifyLabel": "2430000027905977",
			"durationFormat": "2.80时",
			"jumpTypeText": "通过"
		},
		{
			"createTime": "2021-04-01 10:00:22",
			"updateTime": "2021-04-01 12:06:45",
			"createBy": "103922",
			"updateBy": "51585",
			"tenantId": "1",
			"jumpId": "2490000005090539",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "财务复审",
			"nodeId": "sid-9469F9FC-04E7-4F2F-901D-E424B1CE47D9",
			"taskId": "2490000005090538",
			"completeTime": "2021-04-01 12:06:45",
			"duration": 7583193,
			"durationVal": 7583000,
			"handlerId": "51585",
			"ownerId": null,
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": "同意",
			"enableMobile": 1,
			"handleDepId": "1004099",
			"handleDepFull": "360/政企安全集团/财务部",
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "刘娜",
			"handlerInfo": {
				"handler": "刘娜",
				"deptName": "政企安全集团.财务部",
				"photoId": "liuna1@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2490000005090539",
			"checkStatusText": "通过",
			"identifyLabel": "2490000005090539",
			"durationFormat": "2.11时",
			"jumpTypeText": "通过"
		},
		{
			"createTime": "2021-03-31 00:20:04",
			"updateTime": "2021-04-01 10:00:21",
			"createBy": "101177",
			"updateBy": "103922",
			"tenantId": "1",
			"jumpId": "2470000002509939",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "财务初审",
			"nodeId": "sid-423BC902-1B39-4802-ADCF-74DB930C69AA",
			"taskId": "2470000002509938",
			"completeTime": "2021-04-01 10:00:21",
			"duration": 121217388,
			"durationVal": 39621000,
			"handlerId": "103922",
			"ownerId": null,
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": "1、主体为奇虎，无预算<br/>2、2021-2022年天津联通网络单元符合性评测和风险评估服务项目，标的额240万<br/>3、4月2日开标，招标人签订合同后退还保证金<br/>4、需基本户支付，付款无需备注<br/>5、错配主体审批见附件<br/>",
			"enableMobile": 1,
			"handleDepId": "1004099",
			"handleDepFull": "360/政企安全集团/财务部",
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "陈洁",
			"handlerInfo": {
				"handler": "陈洁",
				"deptName": "政企安全集团.财务部",
				"photoId": "chenjie9@360.cn"
			},
			"attachments": [
				{
					"fileName": "Re  业务线主体错配使用申请-2021-2022年天津联通网络单元符合性评测和风险评估服务-使用奇虎科技投标.msg",
					"extName": "msg",
					"fileId": "155344aa952e4613aa46ba67d9c345f5"
				}
			],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2470000002509939",
			"checkStatusText": "通过",
			"identifyLabel": "2470000002509939",
			"durationFormat": "1.40天",
			"jumpTypeText": "通过"
		},
		{
			"createTime": "2021-03-31 00:20:04",
			"updateTime": "2021-03-31 00:20:04",
			"createBy": "101177",
			"updateBy": "101177",
			"tenantId": "1",
			"jumpId": "2470000002509923",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "业务CEO",
			"nodeId": "sid-60EC4AB8-49F1-49E5-8495-019D504D56B7",
			"taskId": "2470000002509922",
			"completeTime": "2021-03-31 00:20:04",
			"duration": 14,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": "NULLUSERSKIP",
			"jumpType": "NULLUSERSKIP",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": {},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2470000002509923",
			"checkStatusText": "审批人为空跳过",
			"identifyLabel": "2470000002509923",
			"durationFormat": "0.01秒",
			"jumpTypeText": "审批人为空跳过"
		},
		{
			"createTime": "2021-03-31 00:20:04",
			"updateTime": "2021-03-31 00:20:04",
			"createBy": "101177",
			"updateBy": "101177",
			"tenantId": "1",
			"jumpId": "2470000002509930",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "商户号审核",
			"nodeId": "sid-4D506581-7BBE-47E5-800A-7E011E99AD1B",
			"taskId": "2470000002509929",
			"completeTime": "2021-03-31 00:20:04",
			"duration": 93,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": "NULLUSERSKIP",
			"jumpType": "NULLUSERSKIP",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": {},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2470000002509930",
			"checkStatusText": "审批人为空跳过",
			"identifyLabel": "2470000002509930",
			"durationFormat": "0.09秒",
			"jumpTypeText": "审批人为空跳过"
		},
		{
			"createTime": "2021-03-30 20:50:08",
			"updateTime": "2021-03-31 00:20:04",
			"createBy": "42917",
			"updateBy": "101177",
			"tenantId": "1",
			"jumpId": "2460000002690525",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "VP",
			"nodeId": "sid-BCED64CE-493F-4C38-86F2-D738409C6A3C",
			"taskId": "2460000002690524",
			"completeTime": "2021-03-31 00:20:04",
			"duration": 12595677,
			"durationVal": 0,
			"handlerId": "101177",
			"ownerId": "101177",
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": "1003936",
			"handleDepFull": "360/政企安全集团/战略行业事业一群",
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "周猛",
			"handlerInfo": {
				"handler": "周猛",
				"deptName": "政企安全集团.战略行业事业一群",
				"photoId": "zhoumeng1@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2460000002690525",
			"checkStatusText": "通过",
			"identifyLabel": "2460000002690525",
			"durationFormat": "3.50时",
			"jumpTypeText": "通过"
		},
		{
			"createTime": "2021-03-30 20:50:08",
			"updateTime": "2021-03-30 20:50:08",
			"createBy": "42917",
			"updateBy": "42917",
			"tenantId": "1",
			"jumpId": "2460000002690511",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "业务管控初审",
			"nodeId": "sid-FDF4C3BF-112D-4E76-9E46-6FCFB70FB8B5",
			"taskId": "2460000002690510",
			"completeTime": "2021-03-30 20:50:08",
			"duration": 61,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": "NULLUSERSKIP",
			"jumpType": "NULLUSERSKIP",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": {},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2460000002690511",
			"checkStatusText": "审批人为空跳过",
			"identifyLabel": "2460000002690511",
			"durationFormat": "0.06秒",
			"jumpTypeText": "审批人为空跳过"
		},
		{
			"createTime": "2021-03-30 20:50:08",
			"updateTime": "2021-03-30 20:50:08",
			"createBy": "42917",
			"updateBy": "42917",
			"tenantId": "1",
			"jumpId": "2460000002690518",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "业务管控复审",
			"nodeId": "sid-2E30D4C1-2D50-4E09-A022-49D787F1F939",
			"taskId": "2460000002690517",
			"completeTime": "2021-03-30 20:50:08",
			"duration": 59,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": "NULLUSERSKIP",
			"jumpType": "NULLUSERSKIP",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": {},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2460000002690518",
			"checkStatusText": "审批人为空跳过",
			"identifyLabel": "2460000002690518",
			"durationFormat": "0.06秒",
			"jumpTypeText": "审批人为空跳过"
		},
		{
			"createTime": "2021-03-30 20:50:07",
			"updateTime": "2021-03-30 20:50:08",
			"createBy": "42917",
			"updateBy": "42917",
			"tenantId": "1",
			"jumpId": "2460000002690503",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "指定业务领导审批",
			"nodeId": "sid-110DC1F0-6A73-42D9-8B82-ECCF5E4B1FF6",
			"taskId": "2460000002690502",
			"completeTime": "2021-03-30 20:50:08",
			"duration": 255,
			"durationVal": null,
			"handlerId": "42917",
			"ownerId": "42917",
			"checkStatus": "SKIP",
			"jumpType": "SKIP",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": "1004056",
			"handleDepFull": "360/政企安全集团/战略行业事业一群/运营商组",
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "张咏梅",
			"handlerInfo": {
				"handler": "张咏梅",
				"deptName": "政企安全集团.战略行业事业一群",
				"photoId": "zhangyongmei@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2460000002690503",
			"checkStatusText": "跳过",
			"identifyLabel": "2460000002690503",
			"durationFormat": "0.26秒",
			"jumpTypeText": "跳过"
		},
		{
			"createTime": "2021-03-30 20:44:37",
			"updateTime": "2021-03-30 20:50:07",
			"createBy": "104349",
			"updateBy": "42917",
			"tenantId": "1",
			"jumpId": "2490000005025739",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "提报部门M级审批(提报部门)",
			"nodeId": "sid-6D285A83-CF02-49D4-9D2D-05B04D049214",
			"taskId": "2490000005025738",
			"completeTime": "2021-03-30 20:50:07",
			"duration": 330302,
			"durationVal": 0,
			"handlerId": "42917",
			"ownerId": "42917",
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": "",
			"enableMobile": 1,
			"handleDepId": "1004056",
			"handleDepFull": "360/政企安全集团/战略行业事业一群/运营商组",
			"sourceType": "Mobile",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": null,
			"handler": "张咏梅",
			"handlerInfo": {
				"handler": "张咏梅",
				"deptName": "政企安全集团.战略行业事业一群",
				"photoId": "zhangyongmei@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2490000005025739",
			"checkStatusText": "通过",
			"identifyLabel": "2490000005025739",
			"durationFormat": "5.51分",
			"jumpTypeText": "通过"
		},
		{
			"createTime": "2021-03-30 20:44:37",
			"updateTime": "2021-03-30 20:44:37",
			"createBy": "104349",
			"updateBy": "104349",
			"tenantId": "1",
			"jumpId": "2490000005025730",
			"actDefId": "WF_1016001037:11:2430000027601132",
			"actInstId": "2490000005025705",
			"nodeName": "申请人申请",
			"nodeId": "sid-9E1C2066-4B55-4072-8296-7E50E6992F32",
			"taskId": "2490000005025728",
			"completeTime": "2021-03-30 20:44:37",
			"duration": null,
			"durationVal": null,
			"handlerId": "104349",
			"ownerId": "104349",
			"checkStatus": "AGREE",
			"jumpType": "AGREE",
			"remark": null,
			"enableMobile": 1,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": "沙楠",
			"handlerInfo": {
				"handler": "沙楠",
				"deptName": "政企安全集团.战略行业事业一群",
				"photoId": "shanan@360.cn"
			},
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": "",
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": "2490000005025730",
			"checkStatusText": "通过",
			"identifyLabel": "2490000005025730",
			"durationFormat": "0秒",
			"jumpTypeText": "通过"
		},
		{
			"createTime": null,
			"updateTime": null,
			"createBy": null,
			"updateBy": null,
			"tenantId": null,
			"jumpId": null,
			"actDefId": null,
			"actInstId": null,
			"nodeName": null,
			"nodeId": null,
			"taskId": null,
			"completeTime": "2021-03-30 20:44:37",
			"duration": null,
			"durationVal": null,
			"handlerId": null,
			"ownerId": null,
			"checkStatus": null,
			"jumpType": null,
			"remark": null,
			"enableMobile": 0,
			"handleDepId": null,
			"handleDepFull": null,
			"sourceType": "PC",
			"subject": "",
			"status": "",
			"name": "",
			"opinionName": "",
			"handler": null,
			"handlerInfo": null,
			"attachments": [],
			"currApproveUserList": [],
			"sourceTaskId": null,
			"level": null,
			"nextJumpType": null,
			"taskType": null,
			"agentUserId": null,
			"handlerEntiy": null,
			"bpmNodeJumpRisk": null,
			"labelColor": null,
			"labelName": null,
			"pkId": null,
			"checkStatusText": null,
			"identifyLabel": null,
			"durationFormat": "0秒",
			"jumpTypeText": ""
		}
	]
    }
  }
}
</script>
<style lang="scss" scoped>

</style>